export const API = `${process.env.REACT_APP_API_URL}/api`;
export const formatNumber = (value) => {
  if (value === null || value === undefined) return "0";
  return new Intl.NumberFormat().format(value);
};
export const PAGE_SIZE_OPTIONS = [
  { value: "10", label: "10" },
  { value: "25", label: "25" },
  { value: "50", label: "50" },
  { value: "100", label: "100" },
  { value: "500", label: "500" },
  { value: "1000", label: "1000" },
  { value: "1500", label: "1500" },
];
export const PAGE_SIZE_OPTIONS_REPORT = [
  { value: "10", label: "10" },
  { value: "25", label: "25" },
  { value: "50", label: "50" },
  { value: "100", label: "100" },
  { value: "500", label: "500" },
  { value: "1000", label: "1000" },
  { value: "1500", label: "1500" },
];

export const allPermissions = [
  "dashboard-view",
  "dropoffs-view",
  "dropoffs-create",
  "orders-view",
  "orders-show",
  "orders-ship",
  "orders-cancel",
  "shipments-view",
  "shipments-create",
  "shipments-show",
  "shipments-edit",
  "shipments-delete",
  "shipments-calldriver",
  "wallets-view",
  "wallets-show",
  "wallets-approve",
  "wallets-reverse",
  "users-view",
  "users-create",
  "users-show",
  "users-edit",
  "users-delete",
  "users-assign-role",
  "users-activate",
  "users-deactivate",
  "categories-view",
  "categories-create",
  "categories-show",
  "categories-edit",
  "categories-delete",
  "products-view",
  "products-create",
  "products-show",
  "products-edit",
  "products-delete",
  "productvariants-view",
  "productvariants-create",
  "productvariants-edit",
  "productvariants-delete",
  "warehouses-view",
  "warehouses-create",
  "warehouses-edit",
  "warehouses-delete",
  "warehouses-activate",
  "warehouses-deactivate",
  "regions-view",
  "regions-create",
  "regions-edit",
  "regions-show",
  "regions-delete",
  "roles-view",
  "roles-create",
  "roles-edit",
  "roles-delete",
  "roles-show-users",
];
export const formatStatus = (status) => {
  if (!status) return "";
  return status
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
export const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const MAX_FILE_SIZE = 2 * 1024 * 1024;
export const StatusColors = {
  APPROVED: "#2e7d32",
  PENDING: "#ed6c02",
  DISAPPROVED: "#d32f2f",
  COMPLETED: "#2e7d32",
};
